import {
  // isEmpty,
  isNumber,
  isFunction
} from 'lodash'
import { logger } from '../../utils'

import {
  BETSLIP_VIOLATION
} from '../../error'

const SCRIPTS_RULES = {
  /*
    Scenario for default betslip validation after updates
    that adding/removing bets and requires recounting & revalidation

    Currenty not using
    'post-update': constant(null),
  */

  /*
    Scenario for quick betslip validation before adding new bet
    preventing from adding bet and applying errors
  */
  'pre-quick-add': state => {
    // Betslip quickbet amount verification
    // Bet amount should bet positive number value
    if (!isNumber(state.amount) || (state.amount <= 0)) {
      return {
        noamount: {
          violations: [
            {
              code: BETSLIP_VIOLATION.BET_AMOUNT_REQUIRED
            }
          ]
        }
      }
    }

    return null
  }
}

export default class BetslipValidator {
  /*
    Method for validating betslip state by scenario
  */
  validateScenario (scenario, state) {
    const scriptValidator = SCRIPTS_RULES[scenario]

    if (scriptValidator && isFunction(scriptValidator)) {
      logger.debug('[betslip:validation]', `validating betslip#${state.id} scenario=${scenario}; state=`, state)

      return scriptValidator(state)
    }

    logger.debug('[betslip:validation]', `validation scenario=${scenario} not found; betslip#${state.id}`)
    return null
  }
}
